module.exports = __webpack_public_path__ + "img/planejamento_familiar.fcc134ad.png";